import sanitizeHtml from 'sanitize-html'

function decodeCommonHtmlEntities(value: string): string {
  return value
    .replaceAll('&nbsp;', ' ')
    .replaceAll('&amp;', '&')
    .replaceAll('&lt;', '<')
    .replaceAll('&gt;', '>')
    .replaceAll('&quot;', '"')
    .replaceAll('&#39;', "'")
}

function looksLikeHtml(input: string): boolean {
  return /<(?:\/?(?:div|p|br|li|blockquote|ul|ol|h[1-6]|span|strong|em)\b)[^>]*>/i.test(
    input,
  )
}

/**
 * Normalize a message to plain text (no HTML) while keeping human-readable line breaks.
 * Handles rich-text editor outputs like `<div><br></div><div>...</div>`.
 */
export function normalizePlainTextMessage(input: unknown): string {
  if (typeof input !== 'string') {
    return ''
  }

  const raw = input.replaceAll('\r\n', '\n').replaceAll('\r', '\n')
  const decoded = decodeCommonHtmlEntities(raw)
  if (!decoded.trim()) {
    return ''
  }

  if (!looksLikeHtml(decoded)) {
    return decoded
      .split('\n')
      .map((line) => line.trimEnd())
      .join('\n')
      .replaceAll(/[ \t]+/g, ' ')
      .replaceAll(/\n{3,}/g, '\n\n')
      .trim()
  }

  const withBreaks = decoded
    // Line breaks
    .replaceAll(/<br\s*\/?>/gi, '\n')
    // Closing block tags as paragraph breaks
    .replaceAll(/<\/\s*(div|p|li|blockquote|h[1-6]|ul|ol)\s*>/gi, '\n')

  const stripped = sanitizeHtml(withBreaks, {
    allowedTags: [],
    allowedAttributes: {},
    disallowedTagsMode: 'discard',
  })

  return decodeCommonHtmlEntities(stripped)
    .replaceAll(/[ \t]+/g, ' ')
    .replaceAll(/\u00a0/g, ' ')
    .replaceAll(/\n[ \t]+/g, '\n')
    .replaceAll(/[ \t]+\n/g, '\n')
    .replaceAll(/\n{3,}/g, '\n\n')
    .trim()
}
